module.exports = __webpack_public_path__ + "static/media/disposuite_sld.16947e24.png";